export enum SafariPortalIconStyles {
  // font-awesome icon styles
  SOLID = 'solid',
  REGULAR = 'regular',
  LIGHT = 'light',
  THIN = 'thin',
  // custom icons
  CUSTOM = 'custom',
}
